import { RICH_TEXT_BOX_ROLE } from '@wix/wix-data-client-common-standalone'

import { type RichTextBoxProps } from '../types'
import {
  assertNonNullable,
  assertRichTextBoxProps,
  setConnectionConfigPropertyField,
} from '../utils'
import { addComponentForField } from './addComponentForField'
import { type FieldComponentAdder } from './types'

export const addComponentForRichTextField: FieldComponentAdder = ({
  fieldKey,
  fieldName,
  page,
  templateComponentByVeloId,
  templateControllerConnectionsByVeloId,
}) =>
  addComponentForField({
    page,
    templateComponentByVeloId,
    templateControllerConnectionsByVeloId,
    templateVeloId: 'richTextFieldTemplate',
    componentAdjustments: {
      modifyComponent: component => {
        assertNonNullable(component.props)
        assertRichTextBoxProps(component.props)
        const props: RichTextBoxProps = { ...component.props, label: fieldName }
        return { ...component, props }
      },
      connectionConfigModifierByRole: {
        [RICH_TEXT_BOX_ROLE]: config =>
          setConnectionConfigPropertyField({
            config,
            propertyName: 'value',
            fieldKey,
          }),
      },
      veloId: `${fieldKey}Field`,
    },
  })
